import React from "react";

const TabComponent = ({ tabs, selectedTab, onSelectTab }) => {
  return (
    <div className="w-full h-[34px] flex items-center space-x-2">
      {tabs.map((tab, index) => {
        // A tab may carry a fixed id (fax.jsx skips tabs per practice);
        // without one its position is its id.
        const id = tab.id ?? index;
        return (
        <div
          key={id}
          onClick={() => onSelectTab(id)}
          className={`flex items-center shadow-md rounded-full px-3 py-1 [font-family:'Inter-Regular',Helvetica] tracking-[0] text-lg font-normal whitespace-nowrap cursor-pointer ${
            selectedTab === id
              ? "bg-[#e17954]  text-white"
              : "bg-white text-[#1d2951]"
          }`}
          style={{ fontSize: '15px' }}
        >
          {tab.label}
         

        </div>
        );
      })}
    </div>
  );
};

export default TabComponent;
